import {status_ru_m as status,roles} from "../factdata";
import {dateRenderer} from "../../services/formatSvc";

export const mapMembersDataAfterPagination = (result,query) => {
    return {
        data: result.data.map((e) => {
            e.fullName = `${e?.lastName} ${e?.firstName} ${e?.middleName}`;
            e.headName = e.proj?.head?.displayName;
            e.isYoungString = e.isYoung ? 'Да' : 'Нет';
            e.roleString = roles[e.role] ?? '1';
            e.statusString = status[e.status] || e.status;
            e.nameProj = e.proj?.fullNumber + " " + e.proj?.name;
            e.employmentDateString = dateRenderer(e.employmentDate);
            e.exclusionDateString = dateRenderer(e.exclusionDate);
            e.inclusionDateString = dateRenderer(e.inclusionDate);
            return e;
        }),
        page: query?.page,
        totalCount: result?.count
    }
}